import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld';
import axios from 'axios'
import request from '@/utils/request.js'
Vue.use(Router);
//清除缓存
function clearCache() {
   localStorage.removeItem("Token");
   localStorage.removeItem("UserName");
   localStorage.removeItem("UserAccount");
   localStorage.removeItem("DepartmentName");
   localStorage.removeItem("DefaultPage");
   localStorage.removeItem("UserRole");
   localStorage.removeItem("ExpireTime");
   localStorage.removeItem("SsoType")
}
 function  SsoLoginApi(e) {
      axios({
        url: "UserLogin/SSOInit", //1、请求地址
        method: "get", // 2、请求方法
        responseType: "application/json; charset=utf-8",
        headers: {
          Accept: "application/json; charset=utf-8",
        },
        params: {
          urlType: e.urlType,
          token: e.token
        }
      })
        // 2、回调函数
        .then(resp => {
          var redirectUrl = resp.data.DomainObj;
          window.location.href = redirectUrl;
        }).catch(err => {
          console.log(err,'errr')
        });
}
function getExpireStatus() {
  var expireTime = localStorage.getItem("ExpireTime");
  var status = true;
  if (expireTime != undefined && expireTime != "")
  {
    var date = new Date(expireTime);
    var expireStamped = date.valueOf();
    if (isNaN(expireStamped)) {
     return status = true;
    }
    else {
    var dateNowTime = Date.now();
    //判断是否过期
    status = dateNowTime > expireStamped ? true : false;
    }
  }
  return status;
}
 function   getSsoUrl(e) {
            request.get('Sso/GetSsoUrl', {
                params: {
                    SsoUrlType: e.ssoUrlType,
                    CallbackUrl: e.callbackUrl
                }
            }).then(res => {
        if (res.data.ResponseCode == 200 && res.data.DomainObj) {
          window.location.href = res.data.DomainObj;
          common.SetSsoType(1) //设置为1 代表不需要验证App里的单点逻辑
          console.log(res, '地址')
        }
        else {
          this.$alert(res.data.Message, '异常', {
            confirmButtonText: '确定',
            callback: action => {
              console.log('回调')
            }
            });
          }
          console.log('res', res)
          })
}

 function getSingleLogin() {
    getSsoUrl({ ssoUrlType: 'NetflowUserLoginCallbackUrl', callbackUrl: window.location.href});
}
// 路由拦截
// router.beforeEach((to, from, next) => {
//   // ... 其他逻辑

//   // 检查版本更新
//   if (from.path !== '/') {
//     checkAppNewVersion()
//   }

// })
// // 检查服务端是否已经更新，如果更新刷新页面
// async function checkAppNewVersion() {
//   const url = `/version.json?t=${Date.now()}`
//   let res = null
//   try {
//     res = await axios.get(url)
//   } catch (err) {
//     console.error('checkAppNewVersion error: ', err)
//   }
//   if (!res) return
//   const version = res.data.version
//   const localVersion = Local.get(localKeys.APP_VERSION)
//   if (localVersion && localVersion !== version) {
//     Local.set(localKeys.APP_VERSION, version)
//     window.location.reload()
//   }
//   Local.set(localKeys.APP_VERSION, version)
// }

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../view/Home.vue') //默认页
    },{
      path: '/CustomsClearanceConsole/ExportDeclaration',
      name: 'ExportDeclaration',
      component: () => import('../view/CustomsClearanceConsole/ExportDeclaration.vue')
    },{
      path: '/Home',
      name: 'Home',
      component: () => import('../view/Home.vue')
    },{
      path: '/other',
      name: 'other',
      component: () => import('../view/other.vue')
    },{
      path: '/DataCentre/DocumentWarehouse',
      name: 'DocumentWarehouse',
      component: () => import('../view/DataCentre/DocumentWarehouse.vue')
    },{
      path: '/DataCentre/BusinessStatistics',
      name: 'BusinessStatistics',
      component: () => import('../view/DataCentre/BusinessStatistics.vue')
    },
    {
      path: '/DataCentre/ActionAccounting',
      name: 'ActionAccounting',
      component: () => import('../view/ActionAccounting/index.vue')
    },
    {
      path: '/EnterpriseConsole/EssentialInformation',
      name: 'EssentialInformation',
      component: () => import('../view/EnterpriseConsole/EssentialInformation.vue')
    },{
      path: '/EnterpriseConsole/AccountManagement',
      name: 'AccountManagement',
      component: () => import('../view/EnterpriseConsole/AccountManagement.vue')
    },{
      path: '/PersonalCenter/EssentialInformation',
      name: 'EssentialInformation',
      component: () => import('../view/PersonalCenter/EssentialInformation.vue')
    },{
      path: '/FilePreview/FilePreview',
      name: 'FilePreview',
      component: () => import('../view/FilePreview/FilePreview.vue'),
      meta: {
        isMenu: false // 是否显示菜单
      }
    },{
      path: '/view/Home',
      name:'Home',
      component: resolve => require(['../view/Home.vue'], resolve)
    },{
      path: '/User/Activate',
      name:'Activate',
      component: resolve => require(['../view/User/Activate.vue'], resolve)
    },{
      path: '/ThirdPartyEmbed/OrderSingleEntrustPage',
      name: 'OrderSingleEntrustPage',
      component: () => import('../view/ThirdPartyEmbed/OrderSingleEntrustPage.vue')
    },{
      path: '/ThirdPartyEmbed/OrderSingleEntrustTool',
      name: 'OrderSingleEntrustTool',
      component: () => import('../view/ThirdPartyEmbed/OrderSingleEntrustTool.vue')
    },{
      path: '/ThirdPartyEmbed/WeChatSubscribe',
      name: 'WeChatSubscribe', 
      component: () => import('../view/ThirdPartyEmbed/WeChatSubscribe.vue')
    },{
      path: '/ThirdPartyEmbed/ExperienceAccountApply',
      name: 'ExperienceAccountApply',
      component: () => import('../view/ThirdPartyEmbed/ExperienceAccountApply.vue')
    },{
      path: '/Error',
      name: 'Error',
      component: () => import('../view/Error/index.vue')
    },{
      path: '/ThirdPartyEmbed/MessagePanel',
      name: 'MessagePanel',
      component: () => import('../view/ThirdPartyEmbed/MessagePanel.vue'),
      meta: {
        isMenu: false // 是否显示菜单
      },
    },
      {
        path: '/SsoLogin',
        name: 'SsoLogin',
        component: () => import('../view/SsoLogin/index.vue'),
        meta: {
          isMenu:false
        }
    },
       {
        path: '/LoginError',
        name: 'LoginError',
        component: () => import('../view/Error/LoginError.vue'),
        meta: {
          isMenu:false
        }
    },
    {
      path: '/User/Bind',
      name: 'UserBind',
      component: () => import('../view/User/Bind.vue'),
      meta: {
        isMenu: false
      },
    },
    {
      path: '/Login/Login',
      name: 'Login',
      component: () => import('../view/Login/Login.vue'),
      meta: {
        isMenu: false
      },
    }
  ]
})

//全局前置路由，配合浏览器localStorage进行鉴权操作
router.beforeEach((to, from, next) => {
  debugger;
  const routerName = to.name;
  //除去特殊界面单独判断--其他走守卫
  if (routerName == 'OrderSingleEntrustPage'
    || routerName == 'OrderSingleEntrustTool'
    || routerName == 'WeChatSubscribe'
    || routerName == 'ExperienceAccountApply'
    || routerName == 'MessagePanel'
    || routerName == 'Error'
    || routerName == 'SsoLogin'
    || routerName == 'Activate'
    || routerName == 'LoginError'
    || routerName == 'UserBind') {
    localStorage.setItem('SsoType','1')
    next();
  }
  else {
    let token = localStorage.getItem('Token');
    //获取过期状态
    let expireStatus = getExpireStatus();
    //If 过期
    if (expireStatus || token == undefined || token == "") {
      //过期清除缓存
      clearCache();
      getSingleLogin()
    } else {
      next();
    }
  }
})


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js